import { COLORS3, SPACING, ZINDEX } from '@zola/zola-ui/src/styles/emotion';

import styled from '@emotion/styled';

import Label from '~/components/common/form/Label';

export const Container = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${COLORS3.WHITE_100};
  z-index: ${ZINDEX.super};
  padding: 56px ${SPACING.MD};
`;

export const ScreenReaderText = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const CloseButton = styled.button`
  padding: 0;
  outline: none;
  border: none;
  background: none;
  color: ${COLORS3.BLACK_100};
  height: 24px;
  position: absolute;
  right: ${SPACING.S16};
  top: ${SPACING.S16};
`;

export const StyledLabel = styled(Label)`
  display: block;
  margin-bottom: ${SPACING.XS};
`;
